require('./RACircularProgressIcon.scss');

const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

// @assets
const successCheckIcon = require('../../../assets/icons/check_green_Success.svg');
const warningIcon = require('../../../assets/icons/exclam_messageRED.svg');

/**
 * Shows an image with a radial progress bar on it's border
 * @param {number} progress How much progress the progress bar will show
 * @param {number} size     Size in pixels that this icon will have (includes borders)
 * @param {url}    url      The url used for the image.
 */

class RACircularProgressIcon extends React.Component {
    render() {
        const { progress, size, url, nonReached } = this.props;
        const objectiveReached = progress > 100;
        const clamp = (value, min, max) => Math.max(min, Math.min(value, max));
        const rotation = (clamp(progress, 0, 100) * 360) / 100;
        const rotationStyle = `rotate(${rotation}deg)`;
        const successRotation = ((clamp(progress, 100, 200) - 100) * 360) / 100;
        const successRotationStyle = `rotate(${successRotation}deg)`;
        const sliceClassNames = classnames('ra-circular-progress-icon--slice', {
            'ra-circular-progress-icon--slice-complete': rotation > 180,
        });
        const successSliceClassNames = classnames(
            'ra-circular-progress-icon--success-slice',
            {
                'ra-circular-progress-icon--success-slice-complete':
                    successRotation > 180,
            },
        );
        const iconStyle = {
            fontSize: `${size}px`,
        };
        const iconBarStyle = {
            transform: rotationStyle,
        };

        const successIconBarStyle = {
            transform: successRotationStyle,
        };

        let successIcon;
        if (nonReached) {
            successIcon = (
                <img
                    className="ra-circular-progress-icon--success-image"
                    src={warningIcon}
                    alt="checkIcon"
                />
            );
        } else {
            successIcon =
                progress >= 100 ? (
                    <img
                        className="ra-circular-progress-icon--success-image"
                        src={successCheckIcon}
                        alt="checkIcon"
                    />
                ) : null;
        }

        const successBar = objectiveReached ? (
            <div
                className="ra-circular-progress-icon--success-bar"
                style={successIconBarStyle}
            />
        ) : null;
        const successBarBackground =
            objectiveReached && progress < 150 ? (
                <div className="ra-circular-progress-icon--success-bar-background" />
            ) : null;
        return (
            <div className="ra-circular-progress-icon" style={iconStyle}>
                <div className="ra-circular-progress-icon--image-container">
                    <img
                        className="ra-circular-progress-icon--image"
                        src={url}
                        alt=""
                    />
                </div>
                <div className={successSliceClassNames}>
                    {successBarBackground}
                    {successBar}
                    <div className="ra-circular-progress-icon--success-fill" />
                    <div className={sliceClassNames}>
                        <div
                            className="ra-circular-progress-icon--bar"
                            style={iconBarStyle}
                        />
                        <div className="ra-circular-progress-icon--fill" />
                        {successIcon}
                    </div>
                </div>
            </div>
        );
    }
}

RACircularProgressIcon.propTypes = {
    progress: PropTypes.number.isRequired,
    size: PropTypes.number.isRequired,
    url: PropTypes.string.isRequired,
    nonReached: PropTypes.bool,
};

RACircularProgressIcon.defaultProps = {
    nonReached: false,
};

module.exports = RACircularProgressIcon;
